import React from "react";

const PermisosEspaciales = (props) => {
    return (
        <li className="special-permissions profile-item special">
            <div className="clearfix">
                <div className="pull-left">
                    <p>
                        {props.data.Producto}
                        <span className="ti-angle-right"></span>
                        {props.data.Categoria}
                        <span className="ti-angle-right"></span>
                        {props.data.Programa + ": "}
                    </p>
                </div>
                <div className="pull-left">
                    <div className="box-tag">
                        <span>
                            {props.data.Permiso ?
                                props.data.Funcion :
                                <strike>{props.data.Funcion}</strike>}
                        </span>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default PermisosEspaciales;
